const ssa = {
    "loc_leaderboard": "leaderboard",
    "loc_leaderboard_info": "Earn <span>points</span>. The more points you have, the best <span>prizes</span> will be available to you",
    "loc_see_discount": "see discount",
    "loc_turn_sound_off": "turn sound off",
    "loc_turn_sound_on": "turn sound on",
    "loc_discount": "discount",
    "loc_your_discounts": "your discounts",
    "loc_go_to_the_website": "go to the website",
    "loc_welcome": "welcome",
    "loc_what_is_your_name": "create a gaming name",
    "loc_incorect_name": "incorrect name",
    "loc_map_screen": "map screen",
    "loc_go_back": "go back",
    "loc_tutorial": "tutorial",
    "loc_next_tip": "next tip",
    "loc_phone_oriental": "Please, flip your phone for a better experience",
    "loc_pixi_pause": "PAUSE",
    "loc_pixi_pts": "PTS",
    "loc_pixi_discount": "Discount",
    "loc_bg_release_tutorial_1": "Gather three identical tiles in a row, swapping adjacent tiles",
    "loc_bg_release_tutorial_2": "Each tile in a row opens a place of background, clear the whole background to complete the level",
    "loc_drop_product_tutorial": "Move the SuperStay Matte Ink Liquid Lipstick by gathering tiles down to complete the level",
    "loc_fill_bar_tutorial": "Collect tiles in rows to fill the progress bar and complete the level",
    "loc_lose_popup": "LEVEL % FAILED",
    "loc_win_popup": "LEVEL % COMPLETE",
    "loc_hello": "Hello",
    "loc_start_game": "start game",
    "loc_logic_popup_top": "it looks like you're not logged in",
    "loc_logic_popup_bottom": "please log in or create an account",
    "loc_ log_in": "log in ",
    "loc_tutorial_name_fillBar": "«fill the bar» mode",
    "loc_tutorial_name_background_release": "«background release» mode",
    "loc_tutorial_name_drop_product": "«drop product» mode",
    "loc_loading": "LOADING",
    "loc_login_placeholder": "name",
    "loc_play": "play",
    "loc_level": "level",
    "loc_create_account": "CREATE AN ACCOUNT",
    "loc_please_log_in": "PLEASE LOG IN OR",
    "loc_done": "DONE",
    "loc_try_again": "TRY AGAIN",
    "loc_you_win": "YOU WIN!",
    "loc_login": "LOG IN ",
    "loc_login_info": "IT LOOKS LIKE YOU'RE NOT LOGGED IN",
    "loc_oops": "OOPS!",
    "loc_resume": 'RESUME',

};
export default ssa;
